import { FC, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "context/AuthContext";
import styles from "./index.module.css";

const SuccessIllustration: FC = () => (
  <svg width="200" height="140" viewBox="0 0 200 140" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="30" y="30" width="120" height="76" rx="8" fill="#fbbf24" />
    <rect x="50" y="20" width="120" height="76" rx="8" fill="#93c5fd" />
    <rect x="50" y="42" width="120" height="14" fill="#60a5fa" />
    <rect x="62" y="66" width="60" height="8" rx="4" fill="white" fillOpacity="0.7" />
    <rect x="62" y="80" width="40" height="6" rx="3" fill="white" fillOpacity="0.5" />
    <circle cx="148" cy="88" r="22" fill="white" />
    <circle cx="148" cy="88" r="18" fill="#16a34a" />
    <polyline points="138,88 145,95 158,80" stroke="white" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const CrystalSuccess: FC = () => {
  const navigate = useNavigate();
  const authInfo = useContext(AuthContext);

  return (
    <div className={styles["container"]}>
      <div className={styles["content"]}>
        <h1 className={styles["headline"]}>Firewalla Crystal is Ready to Go</h1>
        <p className={styles["subtitle"]}>
          Deploy Firewalla Crystal on any hardware. Simply follow the
          installation guide below to set up your device and secure your network.
        </p>
        <button
          className={styles["start-btn"]}
          onClick={() => navigate("/crystal-licenses")}
        >
          Start Provisioning
        </button>
        <div className={styles["illustration"]}>
          <SuccessIllustration />
        </div>
        <p className={styles["more-info"]}>
          We'll send an email to{" "}
          <span className={styles["email"]}>
            {authInfo.email || "your email"}
          </span>{" "}
          with a link to your account once everything is set up. In the
          meantime, feel free to check out{" "}
          <a
            href="https://help.firewalla.com/hc/en-us/articles/4409866753427"
            target="_blank"
            rel="noreferrer"
          >
            our article
          </a>{" "}
          on Firewalla MSP's key features and capabilities.
        </p>
      </div>
    </div>
  );
};

export default CrystalSuccess;
